<template>
  <Section
    decoration="/images/crosses.svg"
    :index="2"
    :title="t('sections.experience')"
    id="experience"
  >
    <ul>
      <Litem
        v-for="xp in experiences"
        :key="xp.duration"
        border
      >
        <template v-slot:presentation>
          <p class="experience__duration">
            {{ xp.duration }}
          </p>
          <a
            :href="xp.link"
            rel="noopener noreferrer"
            target="_blank"
            class="experience__company"
          >
            {{ xp.title }}
          </a>
        </template>
        <template v-slot:content>
          <p class="experience__role">
            {{ xp.intro }}
          </p>
          <p class="experience__description">
            {{ xp.description }}
          </p>
        </template>
      </Litem>
    </ul>
  </Section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Litem from '@/ui/Litem.vue';
import Section from '@/ui/Section.vue';

type Experience = {
  duration: string;
  title: string;
  link: string;
  intro: string;
  description: string;
};

const { t, tm } = useI18n();

const experiences = computed<Experience[]>(() => tm('experience'));
</script>

<style lang="scss" scoped>
@use '@/styles/mixins';

.experience__duration {
  margin-bottom: 12px;

  @include mixins.monotext;
}

.experience__company {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-weight: 500;
  font-size: 24px;
}

.experience__role {
  color: var(--color-text-strong);
  font-weight: 500;
  margin-bottom: 8px;
}
</style>
